import { render, staticRenderFns } from "./InlineSmsVerification.vue?vue&type=template&id=5413f21a&scoped=true"
import script from "./InlineSmsVerification.vue?vue&type=script&lang=js"
export * from "./InlineSmsVerification.vue?vue&type=script&lang=js"
import style0 from "./InlineSmsVerification.vue?vue&type=style&index=0&id=5413f21a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5413f21a",
  null
  
)

export default component.exports